import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { ZusatztoolsPvEinAusgabe } from './ZusatztoolsPvEinAusgabe';

interface ZusatztoolsPvProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface ZusatztoolsPvState {
    tabIndex: number;
    hasLastDaten: boolean;
    msgLastDaten: string;
}

export class ZusatztoolsPv extends React.Component<ZusatztoolsPvProps, ZusatztoolsPvState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxZusatztoolsPv') || 0,
            hasLastDaten: this.props.data[IDs.ENT_ERZEUGUNGS_LASTDATEN],
            msgLastDaten: 'Lade Lastsimulation ...'
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.checkRouting();
        if (!this.props.data[IDs.ENT_ERZEUGUNGS_LASTDATEN]) {
            this.dataService.loadDataForModul(
                IDs.ENT_ERZEUGUNGS_LASTDATEN, {}, {}, IDs.MOD_ETOOL_ADMIN,
                (result: any) => {
                    if (result && result[IDs.ENT_ERZEUGUNGS_LASTDATEN]) {
                        this.props.data[IDs.ENT_ERZEUGUNGS_LASTDATEN] = result[IDs.ENT_ERZEUGUNGS_LASTDATEN];
                        this.setState({ hasLastDaten: true });
                    } else {
                        this.setState({
                            hasLastDaten: false,
                            msgLastDaten: 'Lastsimulation ist nicht verfügbar, bitte kontaktieren Sie Ihren Berater'
                        });
                    }
                }
            );
        }
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS_PV;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_ZUSATZTOOLS_PV;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxZusatztoolsPv', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        if (!this.state.hasLastDaten) {
            return <div style={{ padding: 20, fontWeight: 'bold' }}>{this.state.msgLastDaten}</div>;
        }
        const disabledExperte: boolean = !this.apiService.isAdmin() && !this.apiService.isBerater();

        const tabRoutings: Array<any> = [
            { path: RoutingIDs.ROUTE_PV_STANDARD },
            { path: RoutingIDs.ROUTE_PV_EXPERTE }
        ];

        return (
            <Tabs
                className={'tabs-zusatztools'}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex}
                // onSelect={
                //     (tabIndex, lastIndex, event) => this.setState(
                //         { tabIndex },
                //         () => this.contextService.set('tabIdxZusatztoolsPv', this.state.tabIndex)
                //     )
                // }
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{display: 'none'}}>
                    <Tab>Standard</Tab>
                    <Tab disabled={disabledExperte}>Experte</Tab>
                </TabList>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 0 ? 1 : 0
                    }}
                >
                    <ZusatztoolsPvEinAusgabe
                        data={this.props.data}
                    />
                </TabPanel>
                <TabPanel
                    style={{
                        flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto', flex: this.state.tabIndex === 1 ? 1 : 0
                    }}
                >
                    <ZusatztoolsPvEinAusgabe
                        data={this.props.data}
                        isExpert
                    />
                </TabPanel>
            </Tabs>
        );
    }
}
